import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfirmDialog } from "@outpave/ds";
import Role from "enums/Role";
import { useCheckUserRole } from "hooks/useCheckUserRole";
import useCardPrograms from "hooks/useCardPrograms";
import { CARD_PROGRAMS_PATH } from "utils/cardPrograms/cardProgramPaths";

const DISMISSED_KEY = "cardProgramActionRequiredDismissed";

const readDismissed = () => {
  try {
    return sessionStorage.getItem(DISMISSED_KEY) === "1";
  } catch {
    return false;
  }
};

const rememberDismissed = () => {
  try {
    sessionStorage.setItem(DISMISSED_KEY, "1");
  } catch {}
};

const CardProgramActionRequiredPrompt: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const isAdminOrHigher = useCheckUserRole(Role.Admin);
  const { programs } = useCardPrograms(!isAdminOrHigher);
  const [dismissed, setDismissed] = useState(readDismissed);

  const open =
    !dismissed &&
    !pathname.startsWith(CARD_PROGRAMS_PATH) &&
    programs.some((program) => program.actionRequired);

  const dismiss = () => {
    setDismissed(true);
    rememberDismissed();
  };

  return (
    <ConfirmDialog
      open={open}
      tone="primary"
      title={t("CardProgramActionRequiredTitle")}
      message={t("CardProgramActionRequiredMessage")}
      confirmLabel={t("Go to card programs")}
      cancelLabel={t("Later")}
      onConfirm={() => {
        dismiss();
        navigate(CARD_PROGRAMS_PATH);
      }}
      onCancel={dismiss}
    />
  );
};

export default CardProgramActionRequiredPrompt;
